import type { FC } from 'react';
import { memo } from 'react';
import { useStore } from 'zustand';

import { StatusTagGroup } from 'Components/Account/Purchases/PurchasesVehicleList/components/StatusBadgeGroup/StatusTagGroup';
import type { EnquiriesStoreState } from 'Features/SellerCommunications/services';
import { ModalFlowStore } from 'Features/SellerCommunications/services';
import { triggerSellerMessagingVehicleRowClickedEvent } from 'Services/analytics/events';
import VehicleData from 'Storybook/peripheral/VehicleData/VehicleData';
import type { VehicleImageMeta } from 'Types/vehicleImage';
import ROUTES from 'Utilities/routes';

import styles from './ModalEnquiryList.module.scss';

type Enquiry = EnquiriesStoreState['enquiries'][number];

interface ModalEnquiryListItemProps {
	enquiryId: Enquiry['enquiryId'];
	leadPhoto: Enquiry['leadPhoto'];
	make: Enquiry['make'];
	model: Enquiry['model'];
	saleId: Enquiry['saleId'];
	slug: Enquiry['state']['slug'];
	vrm: Enquiry['vrm'];
}

export const ModalEnquiryListItem: FC<ModalEnquiryListItemProps> = memo(
	({ enquiryId, leadPhoto, make, model, saleId, slug, vrm }) => {
		const currentStep = useStore(ModalFlowStore, (state) => state.currentStep);

		const handleClick = () => {
			triggerSellerMessagingVehicleRowClickedEvent({
				enquiryId,
				step: currentStep,
			});
		};

		return (
			<a
				className={styles.details}
				data-testid={`seller-comms-vehicle-row-${saleId}`}
				href={`${ROUTES.VEHICLE.as(Number(enquiryId))}`}
				onClick={handleClick}
				target="_blank"
			>
				<VehicleData
					cypressId={`seller-comms-vehicle-data-${saleId}`}
					leadPhoto={{
						meta: {} as VehicleImageMeta,
						url: leadPhoto,
					}}
					make={make}
					model={model}
					prettyVrm={vrm}
				/>
				<StatusTagGroup className={styles.tags} cypressId={`seller-comms-vehicle-tag-group-${saleId}`} slug={slug} />
			</a>
		);
	},
);
